<template>
  <div class="d-flex">
    <div id="querymap" class="mymap border border-2 border-primary"></div>
    <div id="mouse-position" class="mouse-position"></div>
    <queryboard
      @resetpolygon="onresetpolygon"
      @changepolygontype="changepolygontype"
      @selectplace="drawplace"
      @toggledraw="toggledraw"
      :polygon="mypolygon"
    ></queryboard>
    <resultlistboard v-if="loginstate == 'login'"></resultlistboard>
    <cartboard v-if="loginstate == 'login'"></cartboard>

    <div :style="tooltipstyle" class="mytooltip">
      <p class="text-start mt-2 mx-2" v-html="tip"></p>
    </div>
    <div class="cehui">天地图 GS(2023)336号 &nbsp; &nbsp; 甲测资字44100039</div>
  </div>
</template>

<script>
//import { transform } from "ol/proj";
import "ol/ol.css";
import "ol-ext/dist/ol-ext.min.css";
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
//import OSM from "ol/source/OSM";
import Vector from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { FullScreen, ScaleLine } from "ol/control";
import * as olProj from "ol/proj";
import XYZ from "ol/source/XYZ";
import LayerPopup from "ol-ext/control/LayerPopup";
import Style from "ol/style/Style";
import * as olExtent from "ol/extent";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Select from "ol/interaction/Select";
import MousePosition from "ol/control/MousePosition";
import { toStringXY } from "ol/coordinate";
import Draw, { createBox } from "ol/interaction/Draw";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
import queryboard from "./quaryboard.vue";
import resultlistboard from "./resultlistboard.vue";
import cartboard from "./cartboard.vue";
import { useI18n } from "vue-i18n";
import {
  onMounted,
  onUnmounted,
  reactive,
  getCurrentInstance,
  toRefs,
  ref,
} from "vue";
import { click } from "ol/events/condition";
import GeoJSON from "ol/format/GeoJSON";

export default {
  components: {
    queryboard,
    resultlistboard,
    cartboard,
  },
  setup() {
    const { t } = useI18n();
    const state = reactive({
      mypolygon: "",
      loginstate: "logout",
    });
    const datasource = ref("gaode");
    const myfullscreen = ref({ tipLabel: t("querymapmessage.fullscreen") });

    const mapcomponents = {
      currentdataid: "",
      currentsceneid: "1",
      vectorLayer: {}, //查询结果矢量图层
      queryboxLayer: {}, //查询范围矢量图层
      boundarylayer: {}, //天地图行政区划图层
      labellayer: {}, //天地图英文地名标注图层
      baseveclayer: {},
      baseimglayer: {},
      noderegionlayer: {}, //节点区域的矢量图层
      map: {},
      zoomlevel: 10,
      center: olProj.fromLonLat([37.5, 8.82]),
      showquery: false,
      mapextent: [],
      draw: {}, //绘图,在initmap中初始化
      vecsource: {}, //空间过滤框矢量
    };
    const { proxy } = getCurrentInstance();
    const app = getCurrentInstance();
    //挂载querymap vue对象
    onMounted(() => {
      //  console.log(process.env.NODE_ENV)
      //根据登陆，显示或不显示resultboard,cartboard
      if (app.appContext.config.globalProperties.loginstatus == 1)
        state.loginstate = "login";
      else state.loginstate = "logout";

      if(app.appContext.config.globalProperties.basemapfrom=='tdt')
        datasource.value='tdt'
      else datasource.value='gaode'

      initmap();
      proxy.$EventBus.on("showqueryframe", onshowquery); //注册显示结果列表框图
      proxy.$EventBus.on("onlogout", logout); //注册用户登出
      proxy.$EventBus.on("onlogin", login); //注册用户登入
      proxy.$EventBus.on("zoom2item", zoom2item); //注册用户点击地图上的矢量对象
      proxy.$EventBus.on("changelanguage", onchangelanguage);
    });
    //卸载querymap vue对象
    onUnmounted(() => {
      //清理
      console.log("query 卸载");
      var v = mapcomponents.map.getViewport();
      v.parentNode.removeChild(v);
      proxy.$EventBus.off("showqueryframe");
      proxy.$EventBus.off("onlogout");
      proxy.$EventBus.off("onlogin");
      proxy.$EventBus.off("zoom2item");
      proxy.$EventBus.off("changelanguage");
    });
    const satlayername = ref(t("querymapmessage.satellitelayername"));
    const worldlayername = ref(t("querymapmessage.worldlayername"));
    const boundlayername = ref(t("querymapmessage.boundlayername"));
    const labellayername = ref(t("querymapmessage.labellayername"));
    const logout = () => {
      //收到用户退出登录消息，触发事件
      state.loginstate = "logout";
      if (!isobjempty(mapcomponents.vectorLayer))
        mapcomponents.vectorLayer.getSource().clear(); //清理矢量图层
    };
    const login = () => {
      //收到用户登陆消息，触发事件
      state.loginstate = "login";
    };

    function onchangelanguage() {
      mapcomponents.baseimglayer.set(
        "title",
        t("querymapmessage.satellitelayername")
      );
      mapcomponents.boundarylayer.set(
        "title",
        t("querymapmessage.boundlayername")
      );
      mapcomponents.baseveclayer.set(
        "title",
        t("querymapmessage.worldlayername")
      );
      mapcomponents.labellayer.set(
        "title",
        t("querymapmessage.labellayername")
      );
      updatemap();
    }

    function initmap() {
      //初始化openlayer的Map
      var baseveclayer, imglayer, boundarylayer, labellayer;
      let baseimgurl, basevecurl, tdtibourl, tdteiaurl; //分别是天地图的影像、矢量、行政边界、注记连接

      if (app.appContext.config.globalProperties.mapservtype === "offline") {
        baseimgurl = "tdtmirror?servername=tdt&T=img_w&x={x}&y={y}&l={z}";
        basevecurl = "tdtmirror?servername=tdt&T=vec_w&x={x}&y={y}&l={z}";
        tdtibourl = "tdtmirror?servername=tdt&T=ibo_w&x={x}&y={y}&l={z}";
        tdteiaurl = "tdtmirror?servername=tdt&T=cva_w&x={x}&y={y}&l={z}";
      } else {
        if (datasource.value == "tdt") {
          baseimgurl =
            "https://t{0-7}.tianditu.gov.cn/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
          basevecurl =
            "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
          tdtibourl =
            "https://t{0-7}.tianditu.gov.cn/DataServer?T=ibo_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
          tdteiaurl ="https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f";
        } else {
          baseimgurl =
            "https://webst0{1-4}.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}&scl=1&lang=en"; //高德
          basevecurl =
            "https://webst0{1-4}.is.autonavi.com/appmaptile?style=7&x={x}&y={y}&z={z}&scl=1&lang=en"; //高德
        }
      }

      //节点区域矢量图层

      let regionsource = new Vector({
        url: "noderegion",
        format: new GeoJSON(),
      });
      //注册区域数据源载入成功事件
      regionsource.once("featuresloadend", function () {
        //将视图挪动到区域中心，并将视野范围调整到与视图大小相适应
        let rsource = mapcomponents.noderegionlayer.getSource();
        let regionextent = rsource.getExtent();
        let c = [
          (regionextent[0] + regionextent[2]) / 2,
          (regionextent[1] + regionextent[3]) / 2,
        ];
        let view = mapcomponents.map.getView();
        view.setCenter(c);
        let w, h, side;
        w = regionextent[2] - regionextent[0];
        h = regionextent[3] - regionextent[1];
        side = w > h ? w : h;
        let zoom = view.getZoomForResolution(side / 2000);
        view.setZoom(zoom - 1);
      });
      mapcomponents.noderegionlayer = new VectorLayer({
        source: regionsource,
        displayInLayerSwitcher: false,
        style: new Style({
          stroke: new Stroke({
            color: "rgba(250,100,100,5)",
            width: 2.5,
          }),
          fill: new Fill({ color: "rgba(105, 0, 180, 0.2)" }),
        }),
      });

      //矢量也需要用天地图的

      baseveclayer = new TileLayer({
        title: worldlayername.value,
        baseLayer: true,
        preload: Infinity,
        source: new XYZ({
          //url: basevecurl,
          url: basevecurl,
        }),
        projection: "EPSG:3857",
        visible: false,
      });
      imglayer = new TileLayer({
        title: satlayername.value,
        baseLayer: true,
        preload: Infinity,
        source: new XYZ({
          //url: "http://t{0-7}.tianditu.com/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=25e7ad1ded22ea7e97142e7990f0c63f",
          //天地图的本地镜像,到level7级
          //url: url,
          url: baseimgurl,
        }),
        projection: "EPSG:3857",
        visible: true,
      });
      labellayer = new TileLayer({
        title: labellayername.value,
        preload: Infinity,
        source: new XYZ({
          url: tdteiaurl,
        }),
        projection: "EPSG:3857",
        visible: false,
        displayInLayerSwitcher: false,//不显示label层
      });
      boundarylayer = new TileLayer({
        title: boundlayername.value,
        preload: Infinity,
        source: new XYZ({
          url: tdtibourl,
        }),
        projection: "EPSG:3857",
        visible: false,
      });

      let tarobj, view;
      mapcomponents.vecsource = new Vector({ wrapX: false });
      mapcomponents.queryboxLayer = new VectorLayer({
        source: mapcomponents.vecsource,
        displayInLayerSwitcher: false,
        style: new Style({
          stroke: new Stroke({
            color: "rgba(250,100,100,5)",
            width: 1.5,
          }),
          fill: new Fill({ color: "rgba(105, 0, 180, 0.2)" }),
        }),
      });

      tarobj = "querymap";
      view = new View({
        center: olProj.fromLonLat([116.5, 39.82]),
        projection: "EPSG:3857",
        zoom: 4,
      });
      mapcomponents.baseveclayer = baseveclayer;
      mapcomponents.baseimglayer = imglayer;
      mapcomponents.boundarylayer = boundarylayer;
      mapcomponents.labellayer = labellayer;
      mapcomponents.map = new Map({
        target: tarobj,
        controls: [
          new LayerPopup(),
          new FullScreen(myfullscreen),
          new ScaleLine(),
          new MousePosition({
            //经纬度位置
            projection: "EPSG:4326",
            className: "mouse-position",
            coordinateFormat: mycreateStringXY,
            target: document.getElementById("mouse-position"),
            placeholder: "LON,LAT:",
          }),
        ],

        layers: getlayers(),
        //layers: [imglayer,boundarylayer, mapcomponents.queryboxLayer],
        view: view,
      });

      function getlayers() {
        if (datasource.value == "tdt") {
          return [
            baseveclayer,
            imglayer,
            boundarylayer,
            labellayer,
            mapcomponents.queryboxLayer,
            mapcomponents.noderegionlayer,
          ];
        } else {
          imglayer.setVisible(false)
          baseveclayer.setVisible(true)
          return [
            baseveclayer,
            imglayer,
            mapcomponents.queryboxLayer,
            mapcomponents.noderegionlayer,
          ];
        }
      }
      function mycreateStringXY(param) {
        return t("querymapmessage.lonlat") + toStringXY(param, 3);
      }

      var singleselectClick = new Select({
        condition: click,
        hitTolerance: 10,
        filter: function (f) {
          if (f.getProperties().domid == undefined) return false;
          return true;
        },
      });
      mapcomponents.map.addInteraction(singleselectClick);

      singleselectClick.on("select", function (e) {
        //用户选择某一查询结果时触发事件。需要过滤掉绘制矢量
        var param = [];
        var ff = e.target.getFeatures().getArray()[0];
        if (ff == undefined) return;

        var domid = ff.getProperties().domid;
        if (domid == undefined) return;

        param.push(domid);

        proxy.$EventBus.emit("myscrolltodomid", param);
      });
    }

    //在map上注册draw交互
    function addInteraction(type) {
      try {
        if (type == true) {
          mapcomponents.draw.setActive(true);
          return;
        }
        if (type == false) {
          mapcomponents.draw.setActive(false);
          return;
        }
        if (type == "Circle") {
          mapcomponents.draw = new Draw({
            source: mapcomponents.vecsource,
            type: type,
            geometryFunction: createBox(),
          });
        } else {
          mapcomponents.draw = new Draw({
            source: mapcomponents.vecsource,
            type: type,
          });
        }

        mapcomponents.draw.on("drawend", (e) => {
          let json = new GeoJSON();
          let polygonstr;

          let tfeaturn = e.feature.getGeometry().clone();
          tfeaturn.transform("EPSG:3857", "EPSG:4326");
          polygonstr = json.writeGeometry(tfeaturn);
          state.mypolygon = polygonstr;
          mapcomponents.draw.setActive(false);
          setTimeout(function () {
            mapcomponents.map.addInteraction(new DoubleClickZoom());
          }, 100);
        });
        mapcomponents.draw.on("drawstart", () => {
          mapcomponents.vecsource.clear(false);
          var doubleClickZoom = mapcomponents.map
            .getInteractions()
            .getArray()
            .find((interaction) => {
              return interaction instanceof DoubleClickZoom;
            });
          mapcomponents.map.removeInteraction(doubleClickZoom);
        });

        mapcomponents.map.addInteraction(mapcomponents.draw);
      } catch (err) {
        console.log(err);
      }
    }

    //zoom到指定位置
    function zoom2item(features) {
      var go = {};
      go.type = "FeatureCollection";
      go.features = features;
      var geofeatures = new GeoJSON({
        featureProjection: "EPSG:3857",
      }).readFeatures(go);
      var center = olExtent.getCenter(geofeatures[0].getGeometry().getExtent());
      mapcomponents.map.getView().setCenter(center);
      mapcomponents.map.getView().setZoom(9);
    }

    const toggledraw = (activeflag) => {
      if (isobjempty(mapcomponents.draw)) return;
      if (activeflag == true) {
        mapcomponents.draw.setActive(true);
      } else {
        mapcomponents.draw.setActive(false);
      }
    };

    const changepolygontype = (type) => {
      mapcomponents.vecsource.clear(false); //清除上次的draw?
      state.mypolygon = "";
      mapcomponents.map.removeInteraction(mapcomponents.draw);
      addInteraction(type);
    };
    //重置polygon
    const onresetpolygon = () => {
      mapcomponents.vecsource.clear(false);
      state.mypolygon = "";
      if (!isobjempty(mapcomponents.draw)) mapcomponents.draw.setActive(false);
      mapcomponents.queryboxLayer.getSource().clear(false);
      updatemap();
    };
    const drawplace = (features) => {
      if (features.type === "Feature") {
        state.mypolygon = JSON.stringify(features.geometry);
        var nfeatures = [];
        nfeatures[0] = features;
        showfeature(nfeatures, "boundary");
      } else {
        state.mypolygon = JSON.stringify(features[0].geometry);
        showfeature(features, "boundary");
      }
    };
    function onshowquery(features) {
      showfeature(features, "sceneresult");
    }

    function showfeature(features, resulttype) {
      var go = {};
      go.type = "FeatureCollection";
      go.features = features;
      var geofeatures = new GeoJSON({
        featureProjection: "EPSG:3857",
      }).readFeatures(go);
      if (resulttype == "sceneresult") {
        var vectorSource = new Vector({
          features: geofeatures,
        });
        //mapcomponents.vecsource
        mapcomponents.vectorLayer = new VectorLayer({
          source: vectorSource,
          displayInLayerSwitcher: false, //不在popup control中显示
          style: styleFunction,
        });
      }
      if (resulttype == "boundary") {
        mapcomponents.vecsource.clear();
        mapcomponents.vecsource = new Vector({
          features: geofeatures,
        });
        mapcomponents.queryboxLayer = new VectorLayer({
          source: mapcomponents.vecsource,
          style: styleFunction,
        });
        var center = olExtent.getCenter(
          geofeatures[0].getGeometry().getExtent()
        );
        mapcomponents.map.getView().setCenter(center);
        var resolution = mapcomponents.map
          .getView()
          .getResolutionForExtent(
            geofeatures[0].getGeometry().getExtent(),
            mapcomponents.map.getSize()
          );
        var zoom = mapcomponents.map.getView().getZoomForResolution(resolution);
        mapcomponents.map.getView().setZoom(zoom);
      }
      updatemap();
    }
    function updatemap() {
      //清除所有已有的图层
      mapcomponents.map.getLayers().forEach(function (layer) {
        mapcomponents.map.removeLayer(layer);
      });

      var layers = [];
      layers.push(mapcomponents.baseveclayer);
      layers.push(mapcomponents.baseimglayer);
      layers.push(mapcomponents.boundarylayer);
      layers.push(mapcomponents.labellayer);
      if (!isobjempty(mapcomponents.vectorLayer))
        layers.push(mapcomponents.vectorLayer);
      if (!isobjempty(mapcomponents.queryboxLayer))
        layers.push(mapcomponents.queryboxLayer);
      if (!isobjempty(mapcomponents.noderegionlayer))
        layers.push(mapcomponents.noderegionlayer);

      mapcomponents.map.setLayers(layers);
    }

    //矢量的样式
    function styleFunction(feature) {
      var t = feature.getGeometry().getType();
      var featureselected = false;
      if (feature.getProperties().selected == true) featureselected = true;
      var styles = {};
      var strokewidth = 1.5;
      if (t == "Polygon" || t == "MultiPolygon") {
        //没有初始化，按照val值来做映射，预先生成这些样式，避免浪费
        var col = "rgba(200,150,44,5)";
        if (featureselected) {
          col = "rgba(50,150,200,5)";
          strokewidth = 3;
        }

        styles.polygonStyles = new Style({
          stroke: new Stroke({
            color: col,
            width: strokewidth,
          }),
        });
        if (feature.getProperties().type == "place") {
          styles.polygonStyles = new Style({
            stroke: new Stroke({
              color: "blue",
              width: 1.5,
            }),
            fill: new Fill({ color: "rgba(105, 0, 180, 0.2)" }),
          });
        }
        if (feature.getProperties().orbitfeature != undefined) {
          //轨道矢量
          if (feature.getProperties().withquicklook == true) {
            if (feature.getProperties().quicklookokflag == true)
              styles.polygonStyles.getStroke().setColor("Aquamarine");
            else styles.polygonStyles.getStroke().setColor("HotPink");
          } else {
            styles.polygonStyles.getStroke().setColor("gray");
          }
          if (feature.getProperties().sensormode == "ROLL") {
            styles.polygonStyles.getStroke().setLineDash([5, 15]);
            styles.polygonStyles.getStroke().setWidth(1.0);
          } else styles.polygonStyles.getStroke().setLineDash(null);
        }

        return styles.polygonStyles;
      }
    }
    function isobjempty(myobj) {
      if (Object.getOwnPropertyNames(myobj).length === 0) return true;
      //返回false，为空对象
      return false;
      //返回true，不为空对象
    }
    return {
      toggledraw,
      onresetpolygon,
      changepolygontype,
      drawplace,
      ...toRefs(state),
    };
  },
};
</script>


<style scoped>
.mymap {
  position: absolute;
  width: 100vw;
  height: calc(100vh - 105px);
  max-height: 100vh;
}

.mouse-position {
  position: absolute !important;
  bottom: 10px !important;
  right: 20px !important;
  color: white;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0.8;
  font-size: 12px;
}

.cehui {
  position: fixed;
  left: 10%;
  bottom: 5px;
  background-color: #ccc; /* 设置背景颜色 */
  padding: 10px; /* 添加内边距，以增加元素内容和可见性 */
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  font-size: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
}
/* 老挝语字体 */
.lwfont {
  font-family: "Saysettha OT", sans-serif;
}

/* 英语字体 */
.enfont {
  font-family: "Arial", sans-serif;
}
</style>